<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Site />
        <LateralMenu_Site />

        <div class="page-content" id="nos-scenarios">
            <div class="logo"></div>
            <div class="habillage-header"></div>
            <div class="habillage-map"></div>
            <div class="habillage-tombeau-siptah"></div>
            <div class="habillage-secret-mayoko"></div>
            <div class="habillage-gardiens-vichama"></div>
            <div class="habillage-talisman-titans"></div>
            <div class="habillage-legende-ishtar"></div>
            <div class="habillage-bons-cadeaux"></div>

            <div id="nsce-header" class="content">
                <div>
                    <div class="bandeau">
                        <span>- Nos scénarios -</span>
                        <div>
                            <div class="bandeau-wordings">
                                Quelle est votre destination ?
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="lockquest-map" class="content">
                <div>
                    <div class="avion"></div>
                    <div class="destination marqueur-gauche nestor-bomb-simulator">
                        <div class="container" v-on:click="redirect('#nestor-bomb-simulator')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">NESTOR<br />Bomb Simulator</span>
                        </div>
                    </div>
                    <div class="destination marqueur-gauche bon-cadeau">
                       <div class="container" v-on:click="redirect('#bons-cadeaux')">
                           <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">Bons<br />cadeaux</span>
                        </div>
                    </div>
                    <div class="destination marqueur-droite escape-game-siptah">
                        <div class="container" v-on:click="redirect('#tombeau-siptah')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">Le tombeau<br />de Siptah</span>
                            <span class="mention lockquest">ESCAPE GAME</span>
                        </div>
                    </div>
                    <div class="destination marqueur-droite escape-game-mayoko">
                        <div class="container" v-on:click="redirect('#secret-mayoko')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">Le secret<br />de Mayoko</span>
                            <span class="mention lockquest">ESCAPE GAME</span>
                        </div>
                    </div>
                    <div class="destination marqueur-droite escape-game-vichama">
                        <div class="container" v-on:click="redirect('#gardiens-vichama')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">Les gardiens<br />de Vichama</span>
                            <span class="mention lockquest">ESCAPE GAME</span>
                        </div>
                    </div>
                    <div class="destination marqueur-droite escape-game-talisman">
                        <div class="container" v-on:click="redirect('#talisman-titans')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">Le talisman<br />des titans</span>
                            <span class="mention lockquest">ESCAPE GAME</span>
                        </div>
                    </div>
                    <div class="destination marqueur-gauche escape-game-ishtar">
                        <div class="container" v-on:click="redirect('#legende-ishtar')">
                            <span class="name" v-on:mouseover="onMouseOver_destination" v-on:mouseout="onMouseOut_destination">La légende<br />d'Ishtar</span>
                            <span class="mention lockquest">ESCAPE GAME</span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="tombeau-siptah" class="destination content">
                <img src="/public/assets/images/Background-Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah.jpg" 
                    alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />

                <div class="cartouche">
                    <span>Escape Game</span>
                    <div></div>
                </div>

                <div>
                    <div>
                        <h3>Le tombeau de Siptah</h3>
                        <h3 class="italic">
                            Quelque part dans la vallée des Rois, le
                            <br />mystérieux tombeau de Siptah, le Roi-Enfant, a
                            <br />été découvert... Malheureusement, un groupe 
                            <br />de pilleurs de tombes tente d'y pénétrer !
                            <br />Destination Egypte pour votre équipe
                            <br />d'archéologues. Parviendrez-vous à sauver les
                            <br />trésors du tombeau avant qu'ils ne soient
                            <br />perdus à tout jamais ?
                        </h3>
                        <div>
                            <div>
                                <span>Fouille</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Réflexion</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Manipulation</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div>
                            </div>
                        </div>

                        <a v-on:click="reserver_buttonClick('le-tombeau-de-siptah')">Réserver</a><!--
                        --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/6oMJ1yxK4uc')">&nbsp;</a>
                    </div>
                </div>
            </div>

            <div class="photos tombeau-siptah">
                <div class="separateur-top"></div>
                <div class="carousel">
                    <img class="photo_1" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah-Photo1.jpg" 
                        alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />
                    <img class="photo_2" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah-Photo2.jpg" 
                        alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />
                    <img class="photo_3" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah-Photo3.jpg" 
                        alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />
                    <img class="photo_4" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah-Photo4.jpg" 
                        alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />
                    <img class="photo_5" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Tombeau-Siptah-Photo5.jpg" 
                        alt="LE TOMBEAU DE SIPTAH : Quelque part dans la vallée des Rois, le mystérieux tombeau de Siptah, le Roi-Enfant, a été découvert... Malheureusement, un groupe de pilleurs de tombes tente d'y pénétrer ! Destination Egypte pour votre équipe d'archéologues. Parviendrez-vous à sauver les trésors du tombeau avant qu'ils ne soient perdus à tout jamais ?" />
                </div>
                <div class="separateur-bottom"></div>
            </div>

            <div class="content-separateur between-rooms"></div>

            <div id="secret-mayoko" class="destination content">
                <img src="/public/assets/images/Background-Lock%20quest-Escape%20game%20Caen-Secret-Mayoko.jpg" 
                    alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />

                <div class="cartouche">
                    <span>Escape Game</span>
                    <div></div>
                </div>

                <div>
                    <div>
                        <h3>Le secret de Mayoko</h3>
                        <h3 class="italic">
                            Une série de vols a eu lieu dans différents 
                            <br />musées du Japon. Maître Mayoko, aperçu 
                            <br />dans chacun d'entre eux, récemment, est
                            <br />votre principal suspect.
                            <br />Infiltrez son dojo pour en apprendre 
                            <br />plus, il y a sûrement une sombre 
                            <br />histoire là-dessous...
                            <br />
                            <br />
                        </h3>
                        <div>
                            <div>
                                <span>Fouille</span><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Réflexion</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Manipulation</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div>
                            </div>
                        </div>

                        <a v-on:click="reserver_buttonClick('le-secret-de-mayoko')">Réserver</a><!--
                        --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/uYXrivDG_2E')">&nbsp;</a>
                    </div>
                </div>
            </div>

            <div class="photos secret-mayoko">
                <div class="separateur-top"></div>
                <div class="carousel">
                    <img class="photo_1" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Secret-Mayoko-Photo1.jpg" 
                        alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />
                    <img class="photo_2" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Secret-Mayoko-Photo2.jpg"
                        alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />
                    <img class="photo_3" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Secret-Mayoko-Photo3.jpg" 
                        alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />
                    <img class="photo_4" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Secret-Mayoko-Photo4.jpg" 
                        alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />
                    <img class="photo_5" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Secret-Mayoko-Photo5.jpg" 
                        alt="LE SECRET DE MAYOKO : Une série de vols a eu lieu dans différents musées du Japon. Maître Mayoko, aperçu dans chacun d'entre eux, récemment, est votre principal suspect. Infiltrez son dojo pour en apprendre plus, il y a sûrement une sombre histoire là-dessous..." />
                </div>
                <div class="separateur-bottom"></div>
            </div>

            <div class="content-separateur between-rooms"></div>

            <div id="gardiens-vichama" class="destination content">
                <img src="/public/assets/images/Background-Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama.jpg" 
                    alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />

                <div class="cartouche">
                    <span>Escape Game</span>
                    <div></div>
                </div>

                <div>
                    <div>
                        <h3>Les gardiens de Vichama</h3>
                        <h3 class="italic">
                            Au nord du Pérou, le Pululahua s'est réveillé et
                            <br />menace d'entrer en éruption. En évacuant la
                            <br />population, les autorités ont découvert un
                            <br />mystérieux sanctuaire au coeur de la forêt. Les
                            <br />habitants semblent y garder un important
                            <br />secret. Pour le découvrir, immergez-vous dans
                            <br />leur culture et leurs rites avant qu'il ne soit
                            <br />trop tard...
                        </h3>
                        <div>
                            <div>
                                <span>Fouille</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Réflexion</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Manipulation</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div>
                            </div>
                        </div>

                        <a v-on:click="reserver_buttonClick('les-gardiens-de-vichama')">Réserver</a><!--
                        --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/Rhb61fHDwno')">&nbsp;</a>
                    </div>
                </div>
            </div>

            <div class="photos gardiens-vichama">
                <div class="separateur-top"></div>
                <div class="carousel">
                    <img class="photo_1" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama-Photo1.jpg" 
                        alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />
                    <img class="photo_2" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama-Photo2.jpg" 
                        alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />
                    <img class="photo_3" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama-Photo3.jpg" 
                        alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />
                    <img class="photo_4" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama-Photo4.jpg" 
                        alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />
                    <img class="photo_5" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Gardiens-Vichama-Photo5.jpg" 
                        alt="LES GARDIENS DE VICHAMA : Au nord du Pérou, le Pululahua s'est réveillé et menace d'entrer en éruption. En évacuant la population, les autorités ont découvert un mystérieux sanctuaire au coeur de la forêt. Les habitants semblent y garder un important secret. Pour le découvrir, immergez-vous dans leur culture et leurs rites avant qu'il ne soit trop tard..." />
                </div>
                <div class="separateur-bottom"></div>
            </div>

            <div class="content-separateur between-rooms"></div>

            <div id="talisman-titans" class="destination content">
                <img src="/public/assets/images/Background-Lock%20quest-Escape%20game%20Caen-Talisman-Titans.jpg" 
                    alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />

                <div class="cartouche">
                    <span>Escape Game</span>
                    <div></div>
                </div>

                <div>
                    <div>
                        <h3>Le talisman des titans</h3>
                        <h3 class="italic">
                            Le Pr. Lock est sur le point de percer le mystère
                            <br />du Talisman des Titans, la quête de toute une
                            <br />vie. Il a besoin de monter la meilleure équipe
                            <br />pour cette expédition et vous a donné
                            <br />rendez-vous dans son cabinet au Museum
                            <br />d'archéologie de Cambridge pour un entretien.
                            <br />Soyez convaincants, les enjeux pourraient être
                            <br />plus importants qu'ils en ont l'air...
                        </h3>
                        <div>
                            <div>
                                <span>Fouille</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div>
                            </div>
                            <div>
                                <span>Réflexion</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Manipulation</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div>
                            </div>
                        </div>

                        <a v-on:click="reserver_buttonClick('le-talisman-des-titans')">Réserver</a><!--
                        --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/rS-oEtWGKGk')">&nbsp;</a>
                    </div>
                </div>
            </div>

            <div class="photos talisman-titans">
                <div class="separateur-top"></div>
                <div class="carousel">
                    <img class="photo_1" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Talisman-Titans-Photo1.jpg" 
                        alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />
                    <img class="photo_2" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Talisman-Titans-Photo2.jpg" 
                        alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />
                    <img class="photo_3" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Talisman-Titans-Photo3.jpg" 
                        alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />
                    <img class="photo_4" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Talisman-Titans-Photo4.jpg" 
                        alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />
                    <img class="photo_5" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Talisman-Titans-Photo5.jpg" 
                        alt="LE TALISMAN DES TITANS : Le Pr. Lock est sur le point de percer le mystère du Talisman des Titans, la quête de toute une vie. Il a besoin de monter la meilleure équipe pour cette expédition et vous a donné rendez-vous dans son cabinet au Museum d'archéologie de Cambridge pour un entretien. Soyez convaincants, les enjeux pourraient être plus importants qu'ils en ont l'air..." />
                </div>
                <div class="separateur-bottom"></div>
            </div>

            <div class="content-separateur between-rooms"></div>

            <div id="legende-ishtar" class="destination content">
                <img src="/public/assets/images/Background-Lock%20quest-Escape%20game%20Caen-Legende-Ishtar.jpg" 
                    alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />

                <div class="cartouche">
                    <span>Escape Game</span>
                    <div></div>
                </div>

                <div>
                    <div>
                        <h3>La légende d'Ishtar</h3>
                        <h3 class="italic">
                            La traduction d'une ancienne tablette d'écritures
                            <br />cunéiformes vous a conduit dans le village de
                            <br />Nimrod. Bâti sur les ruines de l'antique
                            <br />civilisation Assyrienne, il serait le répère d'une
                            <br />confrérie séculaire gardienne du savoir perdu de
                            <br />la déesse Ishtar.
                            <br />
                            <br /><span class="bold">Une grande épopée en deux chapitres !</span>
                        </h3>
                        <div>
                            <div>
                                <span>Fouille</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Réflexion</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div></div><!--
                                --><div></div>
                            </div>
                            <div>
                                <span>Manipulation</span><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div><!--
                                --><div class="active"></div>
                            </div>
                        </div>

                        <a v-on:click="reserver_buttonClick('la-legende-d-ishtar')">Réserver</a><!--
                        --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/E4P3HS-lGBM')">&nbsp;</a>
                    </div>
                </div>
            </div>

            <div class="photos legende-ishtar">
                <div class="separateur-top"></div>
                <div class="carousel">
                    <img class="photo_1" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Legende-Ishtar-Photo1.jpg" 
                        alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />
                    <img class="photo_2" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Legende-Ishtar-Photo2.jpg" 
                        alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />
                    <img class="photo_3" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Legende-Ishtar-Photo3.jpg" 
                        alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />
                    <img class="photo_4" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Legende-Ishtar-Photo4.jpg" 
                        alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />
                    <img class="photo_5" src="/public/assets/images/Lock%20quest-Escape%20game%20Caen-Legende-Ishtar-Photo5.jpg" 
                        alt="LA LÉGENDE D'ISHTAR : La traduction d'une ancienne tablette d'écritures cunéiformes vous a conduit dans le village de Nimrod. Bâti sur les ruines de l'antique civilisation Assyrienne, il serait le répère d'une confrérie séculaire gardienne du savoir perdu de la déesse Ishtar. Une grande épopée en deux chapitres !" />
                </div>
                <div class="separateur-bottom"></div>
            </div>

            <div class="content-separateur"></div>

            <div id="nestor-bomb-simulator" class="content">
                <div class="cartouche">
                    <span>Bomb Simulator</span>
                    <div></div>
                </div>

                <div class="column">
                    <div>
                        <div>
                            <div class="logo"></div>
                            <div class="wordings">
                                <span>Découvrez NESTOR, le "bomb simulator"</span>
                                <br/><br />
                                Tic-tac... Le compte à rebours a commencé ! Votre équipe a 15 minutes pour désamorcer la bombe. 
                                <br/><br />
                                Qui sera le <span>Démineur</span> ? Lui seul pourra manipuler la bombe... Ou serez-vous un <span>Ingénieur</span> en possession de toutes les instructions ?
                                <br /><br />
                                Communication, logique, sang-froid : la moindre seconde compte ! À chaque partie un défi différent !
                            </div>
                            <a v-on:click="reserver_buttonClick('nestor-bomb-simulator')">Réserver</a><!--
                            --><a class="icon video" v-on:click="voirTrailer_buttonClick('https://www.youtube.com/embed/XPAK_8QFLII')">&nbsp;</a><!--
                            --><a class="icon scores" v-on:click="listeScores_buttonClick()">&nbsp;</a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="bons-cadeaux" class="content">
                <div class="wordings">
                    <span>Bons cadeaux</span>
                    <span>Offrez l'expérience d'une séance d'Escape Game !</span>
                    <span>Personnalisez votre bon cadeau avec un petit mot. Recevez votre
                        <br/>bon numérique à imprimer ou envoyez-le à vos proches.
                    </span>
                </div>

                <div class="bons-cadeaux-container">
                    <div class="bon-cadeau">
                        <div>1</div>
                        <span>Bon 1 personne <br /> 26€<p>* pour une session de 4 joueurs</p></span>
                        <a v-on:click="offrir_buttonClick" data-composition="1">Offrir</a>
                    </div><!--
                    --><div class="bon-cadeau">
                        <div>2</div>
                        <span>Bon 2 personnes <br /> 76€<p>&nbsp;</p></span>
                        <a v-on:click="offrir_buttonClick" data-composition="2">Offrir</a>
                    </div><!--
                    --><div class="bon-cadeau">
                        <div>3</div>
                        <span>Bon 3 personnes <br /> 87€<p>&nbsp;</p></span>
                        <a v-on:click="offrir_buttonClick" data-composition="3">Offrir</a>
                    </div><!--
                    --><br /><!--
                    --><div class="bon-cadeau">
                        <div>4</div>
                        <span>Bon 4 personnes <br /> 104€<p>&nbsp;</p></span>
                        <a v-on:click="offrir_buttonClick" data-composition="4">Offrir</a>
                    </div><!--
                    --><div class="bon-cadeau">
                        <div>5</div>
                        <span>Bon 5 personnes <br /> 115€<p>&nbsp;</p></span>
                        <a v-on:click="offrir_buttonClick" data-composition="5">Offrir</a>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Reservation ref="reservationPopin" />
        <BonCadeau ref="boncadeauPopin" />
        <ListeScores ref="listescoresPopin" />
        <ConfirmationReservation ref="confirmationReservationPopin" />
        <Video ref="videoPopin" />

        <Footer
            seo_contentH1="Lock Quest – Nos scenarios d’escape  game Caen" 
            seo_contentH2="Jeu d'évasion grandeur nature en 60 minutes et activité de loisirs à Caen (Bretteville-sur-Odon)" />
    </div>
</template>

<script>
import HeaderMenu_Site from '../../components/HeaderMenu_Site.vue';
import LateralMenu_Site from '../../components/LateralMenu_Site.vue';
import Footer from '../../components/Footer.vue';
import Reservation from '../../components/Reservation.vue';
import BonCadeau from '../../components/BonCadeau.vue';
import ListeScores from '../../components/ListeScores.vue';
import ConfirmationReservation from '../../components/ConfirmationReservation.vue';
import Video from '../../components/Video.vue';

import anime from 'animejs/lib/anime.es';

export default {
    name: "ScenariosPage",
    components: {
        HeaderMenu_Site,
        LateralMenu_Site,
        Footer,
        Reservation,
        BonCadeau,
        ListeScores,
        ConfirmationReservation,
        Video
    },
    data: () => ({
        avion_firstMove: true,
        avion_isMoving: false,
        is_newRoomEnabled: false,
        mouseEntered: false,
        ovOptions: {
            root: null,
            rootMargin: '0px 0px -50px 0px',
            treshold: 0
        }
    }),
    methods: {
        voirTrailer_buttonClick: function(video_url) {
            this.$refs.videoPopin.popin_videoDisplayed(video_url);
        },
        listeScores_buttonClick: function() {
            let routeData = this.$router.resolve({ name: 'site_resultatspage' });
            window.open(routeData.href, '_blank');
        },
        reserver_buttonClick: function(scenario_slug) {
            this.$refs.reservationPopin.popin_reservationDisplayed(scenario_slug);
        },
        offrir_buttonClick: function(event) {
            var composition = event.target.getAttribute('data-composition');
            this.$refs.boncadeauPopin.popin_boncadeauDisplayed(composition);
        },
        redirect(url) {
            document.location.href = url;
        },
        ovCallbackPadquest(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [-50, 0],
                duration: 500,
                easing: 'linear'
            });
        },
        onMouseOver_destination: function(event) {
            if (!this.mouseEntered) {
                this.mouseEntered = true;

                if (this.avion_isMoving) {
                    return;
                }

                this.avion_isMoving = true;
                if (this.avion_firstMove) {
                    this.avion_firstMove = false;
                }

                var avion = document.querySelector('#lockquest-map div.avion');
                var avion_position = avion.getBoundingClientRect();

                var translateX = avion_position.x + (event.target.offsetParent.offsetLeft - avion_position.x);
                if (event.target.offsetParent.className.indexOf('marqueur-gauche') > 0) {
                    translateX = translateX + event.target.offsetWidth;
                }
                var translateY = avion_position.y + ((event.target.offsetParent.offsetTop + event.target.offsetTop) - avion_position.y) - avion_position.height / 2;

                var self = this;
                anime({
                    targets: '#lockquest-map div.avion',
                    opacity: [(this.avion_firstMove ? 0 : 1), 1],
                    translateX: translateX,
                    translateY: translateY,
                    duration: 500,
                    easing: 'linear',
                    complete: function(anim) {
                        self.avion_isMoving = false;
                    }
                });
            }
        },
        onMouseOut_destination: function(event) {
            if (this.mouseEntered) {
                this.mouseEntered = false;
            }
        }
    },
    mounted() {
        let hash =  document.location.hash.replace('#/nos-scenarios-escape-caen', '');
        switch(hash) {
            case '#le-tombeau-de-siptah-resa-ok':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Tombeau de Siptah', true);
                break;
            case '#le-tombeau-de-siptah-resa-err':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Tombeau de Siptah', false);
                break;
            case '#le-secret-de-mayoko-resa-ok':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Secret de Mayoko', true);
                break;
            case '#le-secret-de-mayoko-resa-err':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Secret de Mayoko', false);
                break;
            case '#les-gardiens-de-vichama-resa-ok':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Les Gardiens de Vichama', true);
                break;
            case '#les-gardiens-de-vichama-resa-err':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Les Gardiens de Vichama', false);
                break;
            case '#le-talisman-des-titans-resa-ok':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Talisman des Titans', true);
                break;
            case '#le-talisman-des-titans-resa-err':
                this.$refs.confirmationReservationPopin.popin_confirmationReservationDisplayed('Le Talisman des Titans', false);
                break;
        }
    }
}
</script>